export const NUMBER_OF_QUANTITY_OPTIONS = 10;
